import { Divider, Flex } from '@banhala/ui-kit';
import { MumulLiveProfile } from './MumulLiveProfile';
import { useMumulLiveProfile } from './hooks/useMumulLiveProfile';

/**
 * EXP1789 변형군 B 전용 섹션 (간판 영역).
 * 미노출(비실험/DEFAULT/리허설 등)이면 렌더하지 않는다.
 */
export const MumulLiveProfileSection = () => {
  const { isVisible, status, marketName, marketImageUrl, onPress, trackingRef } =
    useMumulLiveProfile();

  if (!isVisible || status == null) {
    return null;
  }

  // trackingRef: 실제 뷰포트 진입을 감지해 DISPLAY 로깅을 게이팅 (useMumulLiveProfile 참고)
  return (
    <Flex ref={trackingRef}>
      <MumulLiveProfile
        status={status}
        marketName={marketName}
        marketImageUrl={marketImageUrl}
        onPress={onPress}
      />
      <Divider size={'medium'} />
    </Flex>
  );
};
